module.exports = __webpack_public_path__ + "static/the-art-of-game-design-5ef906c035c31245f72bd6dca2b942d9.jpg";